import styled from 'styled-components'
import content from '../../../styles/_objects/content'

export const Container = styled.div`
  ${content};
`
